import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { getToken, getUserInfo } from '../../api/api';
import { AuthContext } from '../../context/AuthContext';
import '../../index.css'; // Importamos los estilos globales
import './Login.css';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const { login } = useContext(AuthContext);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        try {
            const token = await getToken(email, password);

            if (!token) {
                setError('Credenciales incorrectas');
                return;
            }

            const user = await getUserInfo(token);

            if (!user) {
                setError("No tienes permisos para acceder");
                return;
            }

            login(user.role, token); // Se envian los datos obtenidos
            navigate('/');
        } catch (err) {
            console.error("Error durante el login:", err);
            if (err.response && err.response.data && err.response.data.detail) {
                setError(err.response.data.detail);
            } else {
                setError('Error de conexión. Inténtalo de nuevo.');
            }
        }
    };

    return (
        <div className='container-login'>
            <form className='form-login' onSubmit={handleSubmit}>
                <h1>Iniciar Sesión</h1>
                <div>
                    <label htmlFor="email">Email:</label>
                    <input
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </div>
                <div>
                    <label htmlFor="password">Contraseña:</label>
                    <input
                        type="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </div>
                {error && <div style={{ color: 'red' }}>{error}</div>}
                <button type="submit">Iniciar Sesión</button>
            </form>
        </div>
    );
};

export default Login;
